import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { makeNiceString, timeConverter, makeNiceRpsheetLinks } from './../utils/NiceStrings'
import { getPlayersOnlineAdmin, getTopRpList, getEventList, getRecentActivity, getAuditBreaches, updateAuditBreach } from './../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SubmittedStoriesCard } from '../builder/overview/SubmittedStoriesCard';
import IssuesCard from '../builder/overview/IssuesCard';
import { EventsCard, getEventData } from '../player/overview/EventsCard';
import { getWhoList } from '../player/overview/WhoCard';
import { getTopRpData, TopRPCard } from '../player/overview/TopRPCard';
import Moment from 'moment';
import { getAuditSummary } from '../components/deityRequests';
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

function AdminBreaches() {
    const [auditBreaches, setAuditBreaches] = useState([]);
    const [auditSummary, setAuditSummary] = useState();
    const [pieLabels, setPieLabels] = useState(["ItemOwnership", "Roleplay", "ItemPower"]);
    const [pieData, setPieData] = useState([10, 10, 10]);


    useEffect(() => {
        getAuditBreachesData();
        getAuditSummaryData();
    }, []);

    const getAuditBreachesData = async () => {
        let data = await getAuditBreaches('recent');
        if (data.result) {

            console.log('Breaches', data);
            setAuditBreaches(data.breaches.sort((a, b) => localDataTimeArrayToDate(b.breachDateTime) - localDataTimeArrayToDate(a.breachDateTime)));
        } else {
            setAuditBreaches([]);
        }
    }

    const getAuditSummaryData = async () => {
        let data = await getAuditSummary(1);
        if (data.result) {
            console.log('summary', data);
            setAuditSummary(data.summary);

            console.log('typeCounts', data.summary.typeCounts);
            let x = [];
            pieLabels.map(label => {
                x = [...x, data.summary.typeCounts[label]];
            });
            setPieData(x);
            console.log(x)

        } else {
            setAuditSummary();
        }
    }

    const updateBreach = async (breach, newStatus) => {
        breach.status = newStatus;
        let data = await updateAuditBreach(breach);

        if (data.result) {
            getAuditBreachesData();
        } else {
            setAuditBreaches([]);
        }
    }

    const localDataTimeArrayToFormattedDate = (javaDate) => {
        let d = new Date(javaDate[0], javaDate[1] - 1, javaDate[2], javaDate[3], javaDate[4]);
        return Moment(d).format('DD-MMM-YYYY HH:mm');
    }

    const localDataTimeArrayToDate = (javaDate) => {
        let d = new Date(javaDate[0], javaDate[1] - 1, javaDate[2], javaDate[3], javaDate[4], 0, javaDate[5]);
        return d;
    }

    const data = {
        labels: pieLabels,
        datasets: [
            {
                data: pieData,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(54, 235, 60, 0.2)',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className="container container-wide" id="divMainContent">
            <div style={{
                display: 'flex', flex: 1, flexDirection: 'row', flexWrap: 'wrap', alignItems: "flex-start",
                justifyContent: "flex-start"
            }}>
                <Col xl={2}>
                    <Pie data={data} />
                </Col>
                <Col xl={8}>
                    {auditBreaches.map((breach, index) =>
                        <Row key={index} className={"py-2"}>
                            <p>
                                <strong>{breach.playerName}</strong> - {breach.breachType}
                                {breach.status !== 'Ignore' ?
                                    <span className={"mx-1 px-2 badge text-bg-info"} onClick={() => updateBreach(breach, 'Ignore')}>
                                        Ignore?
                                    </span>
                                    : null}
                                {breach.status === 'Ignore' ?
                                    <span className={"mx-1 px-2 badge text-bg-danger"} onClick={() => updateBreach(breach, 'Escalated')}>
                                        Escalate
                                    </span>
                                    : null}
                            </p>
                            <p>


                                <span>{localDataTimeArrayToFormattedDate(breach.breachDateTime)}</span>

                            </p>
                            <p>
                                {breach.text}
                            </p>
                        </Row>
                    )}
                </Col>

            </div>
        </div>
    )
}

export default AdminBreaches;